var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AnalyticsManager_instances, _a, _AnalyticsManager_instance, _AnalyticsManager_adapters, _AnalyticsManager_flushQueue;
const MESSAGES = {
    init_failed: '[Analytics:Manager] Initialization failed',
    adapter_exists: '[Analytics:Manager] Adapter already registered:',
    adapter_not_found: '[Analytics:Manager] Adapter not found:',
};
export class AnalyticsManager {
    constructor() {
        _AnalyticsManager_instances.add(this);
        _AnalyticsManager_adapters.set(this, new Map());
    }
    static getInstance() {
        if (!__classPrivateFieldGet(_a, _a, "f", _AnalyticsManager_instance))
            __classPrivateFieldSet(_a, _a, new _a(), "f", _AnalyticsManager_instance);
        return __classPrivateFieldGet(_a, _a, "f", _AnalyticsManager_instance);
    }
    setAdapter(adapter) {
        if (__classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").has(adapter.name)) {
            console.error(MESSAGES.adapter_exists, adapter.name);
            return;
        }
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").set(adapter.name, {
            instance: adapter,
            isReady: false,
            isInitializing: false,
            queue: [],
        });
    }
    removeAdapter(name) {
        const adapter = __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").get(name);
        if (!adapter) {
            console.error(MESSAGES.adapter_not_found, name);
            return;
        }
        adapter.instance.destroy();
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").delete(name);
    }
    init() {
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").forEach(adapter => {
            if (adapter.isReady || adapter.isInitializing)
                return;
            adapter.isInitializing = true;
            adapter.instance
                .init()
                .then(success => {
                if (success) {
                    adapter.isReady = true;
                    __classPrivateFieldGet(this, _AnalyticsManager_instances, "m", _AnalyticsManager_flushQueue).call(this, adapter);
                }
            })
                .catch(error => {
                console.error(MESSAGES.init_failed, error);
                adapter.queue = [];
            })
                .finally(() => {
                adapter.isInitializing = false;
            });
        });
    }
    sendEvent(action, data) {
        if (!__classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").size)
            return false;
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").forEach(adapter => {
            if (!adapter.isReady) {
                adapter.queue.push({ action, data });
                return;
            }
            adapter.instance.sendEvent(action, data);
        });
        return true;
    }
    addGlobalProperties(properties) {
        if (!__classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").size)
            return false;
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").forEach(adapter => adapter.instance.addGlobalProperties(properties));
        return true;
    }
    checkUserChanged() {
        return [...__classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").values()]
            .map(adapter => adapter.instance.checkUserChanged())
            .some(Boolean);
    }
    destroy() {
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").forEach(adapter => adapter.instance.destroy());
        __classPrivateFieldGet(this, _AnalyticsManager_adapters, "f").clear();
    }
}
_a = AnalyticsManager, _AnalyticsManager_adapters = new WeakMap(), _AnalyticsManager_instances = new WeakSet(), _AnalyticsManager_flushQueue = function _AnalyticsManager_flushQueue(adapter) {
    while (adapter.queue.length > 0) {
        const event = adapter.queue.shift();
        adapter.instance.sendEvent(event.action, event.data);
    }
};
_AnalyticsManager_instance = { value: null };
